<div *ngIf="loading" class="vehicle-info-skeleton d-flex flex-row ml-4">
  <div class="vehicle-left">
    <div class="skeleton skeleton-img"></div>
  </div>
  <div class="vehicle-right ml-4">
    <div class="vehicle-info-content">
      <span class="skeleton skeleton-title"></span>
    </div>
    <div class="vehicle-info-description d-flex flex-wrap align-items-center">
      <div class="skeleton skeleton-text"></div>
      <!-- <span class="line-separation"></span> -->
      <div class="skeleton skeleton-text"></div>
      <!-- <span class="line-separation"></span> -->
      <div class="skeleton skeleton-text"></div>
      <!-- <span class="line-separation"></span> -->
      <div class="skeleton skeleton-text"></div>
    </div>
  </div>
</div>

<!-- Main vehicle info block -->
<div *ngIf="!loading">
  <div class="d-flex flex-row ml-4">
    <div class="vehicle-left">
      <img class="vehicle-info-logo" [src]="vehicleLogoPath ? vehicleLogoPath : 'assets/images/not-available-brand.svg'" height="60px" width="64px" alt="vehicle logo" (error)="onLogoError($event)">
    </div>
    <div class="vehicle-right ml-4">
      <div class="vehicle-info-content">
        <span class="vehicle-info-title">{{'dimbo.i18n.header.vehicleInformation' | translate}}</span>
      </div>
      <div *ngIf="screenWidth>400">
        <div class="vehicle-info-description d-flex flex-wrap align-items-center">
          <div>
            <span>{{ vehicleBrand || "N/A" }}</span>
          </div>
          <span class="line-separation"></span>
          <div>
            <span>{{ vehicleModel || "N/A" }}</span>
          </div>
          <span class="line-separation"></span>
          <div>
            <span>VIN:</span>&nbsp;
            <span>{{ vin || "N/A" }}</span>
          </div>
          <span class="line-separation"></span>
          <div>
            <span >{{'dimbo.i18n.label.warrantyStartDate' | translate}}</span>:&nbsp;
            <span>
              <ng-container *ngIf="vehicleWarrantyStartDate; else naDate">
                <!-- Start: CAP-39922 DMBR-64 -->
                {{ vehicleWarrantyStartDate | date: 'dd/MM/yyyy' }}
                <!-- End: CAP-39922 DMBR-64 -->
              </ng-container>
              <ng-template #naDate>N/A</ng-template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Display this element when screen size is less than 400px -->
  <div class="ml-4 mt-1" *ngIf="screenWidth<400">
    <div class="vehicle-info-description d-flex flex-wrap align-items-center">
      <div>
        <span>{{ vehicleBrand || 'N/A' }}</span> 
      </div>
      <span class="line-separation"></span>
      <div>
        <span>{{ vehicleModel || 'N/A' }}</span> 
      </div>
      <span class="line-separation"></span>
  
      <div>
        <span>VIN:</span>&nbsp;
        <span style="font-family:none">{{ vin || 'N/A' }}</span> 
      </div>
      <span class="line-separation"></span>
      <div>
        <span >{{'dimbo.i18n.label.warrantyStartDate' | translate}}</span>:&nbsp;
        <span>
          <ng-container *ngIf="vehicleWarrantyStartDate; else naDate">
            <!-- Start: CAP-39922 DMBR-64 -->
            {{ vehicleWarrantyStartDate | date: 'dd/MM/yyyy' }}
            <!-- End: CAP-39922 DMBR-64 -->
          </ng-container>
          <ng-template #naDate>N/A</ng-template>
        </span>
      </div>
    </div>
  </div>
</div>
